import { useMemo, useState } from "react";
import { PageHero } from "../components/PageHero";
import { CTABand } from "../components/CTABand";
import { FadeUp, ImageCard } from "../components/Reveal";
import { useContent } from "../context/ContentContext";

export default function Portfolio() {
  const { projects, pages } = useContent();
  const [filter, setFilter] = useState("Alles");

  const categories = useMemo(
    () => ["Alles", ...Array.from(new Set(projects.map((p) => p.category)))],
    [projects]
  );
  const visible = filter === "Alles" ? projects : projects.filter((p) => p.category === filter);

  return (
    <main data-testid="portfolio-page">
      <PageHero eyebrow="Portfolio" title={pages.portfolio.title} intro={pages.portfolio.intro} />

      <section className="bg-white">
        <div className="mx-auto max-w-[1400px] px-4 pb-14 sm:px-6">
          <FadeUp>
            <div data-testid="portfolio-filter" className="mb-10 flex flex-wrap gap-2 border-y border-[#E2E0D9] py-4">
              {categories.map((cat) => (
                <button
                  key={cat}
                  type="button"
                  data-testid={`portfolio-filter-${cat.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  onClick={() => setFilter(cat)}
                  aria-pressed={filter === cat}
                  className={`rounded-[4px] border px-4 py-2 font-display text-xs font-bold uppercase tracking-wide transition-colors duration-200 ${
                    filter === cat
                      ? "border-[#111111] bg-[#111111] text-white"
                      : "border-[#D8D6D0] bg-white text-[#555555] hover:border-[#111111] hover:text-[#111111]"
                  }`}
                >
                  {cat}
                  <span className={`ml-2 ${filter === cat ? "text-cream" : "text-[#B9B7B0]"}`}>
                    {cat === "Alles" ? projects.length : projects.filter((p) => p.category === cat).length}
                  </span>
                </button>
              ))}
            </div>
          </FadeUp>
          <div className="grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">
            {visible.map((p, i) => (
              <FadeUp key={p.slug} delay={(i % 3) * 0.05}>
                <ImageCard to={`/portfolio/${p.slug}`} image={p.image} label={p.title} testid={`portfolio-item-${i}`} />
              </FadeUp>
            ))}
          </div>
          {visible.length === 0 && (
            <p data-testid="portfolio-empty" className="text-[15px] text-[#555555]">
              Nog geen projecten in deze categorie.
            </p>
          )}
        </div>
      </section>

      <CTABand
        title="Staat jouw project hier straks tussen?"
        text="Vertel me wat je in gedachten hebt. Ik denk mee en maak een heldere, vrijblijvende offerte."
      />
    </main>
  );
}
